import { render, staticRenderFns } from "./tab-grid.vue?vue&type=template&id=6cdf1b8b&scoped=true"
var script = {}
import style0 from "./tab-grid.vue?vue&type=style&index=0&id=6cdf1b8b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdf1b8b",
  null
  
)

export default component.exports